import { BaseBus } from "./BaseBus";
import { DateFunctions } from "../static/date-functions";

export class v_SupplierLocationBus extends BaseBus
{
    constructor(data: v_SupplierLocationBus = null) {
        super(data);
        if (data) {
            this.certInsuranceEndDt = DateFunctions.getDate(data.certInsuranceEndDt);
        }
    }
    supplierLocationId: any;
    supplierId: any;
    supplierLocationName: string;
    emailAddress: string;
    workNumber: string;
    workExt: string;
    mobileNumber: string;
    faxNumber: string;
    addressName: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressLine4: string;
    city: string;
    stateProvince: string;
    countryCd: string;
    county: string;
    postalCode: string;
    isActive: boolean;
    isSubContract: boolean;
    isPreferred: boolean;
    termId: string;
    certInsuranceEndDt: Date;
    accountNumber: string;
    sageId: number;
    co: number;
    isCompliant: boolean;
    markUp: number;
    margin: number;
    get isCertExpired() : boolean {
        return DateFunctions.dateDiffHours(this.certInsuranceEndDt) > 0;
    }
}